import { Injectable } from '@angular/core';
import { CampaignTemplateDataService } from '../data-services/campaign-template-data.service';
import { TargetGroupRequestModel } from '../business-entities/campaign-modal';

@Injectable({
  providedIn: 'root'
})
export class CampaignTemplateService {

  constructor(private campaignTemplateDataService: CampaignTemplateDataService) { }

  getAllTemplate(requestModal: TargetGroupRequestModel): Promise<any>{
    return this.campaignTemplateDataService.getAllTemplate(requestModal);
  }

  getTemplateById(id: any): Promise<any>{
    return this.campaignTemplateDataService.getTemplateById(id);
  }

  getTemplateByChannel(channel: any): Promise<any>{
    return this.campaignTemplateDataService.getTemplateByChannel(channel);
  }

  addUpdateTemplate(template: any): Promise<any>{
    return this.campaignTemplateDataService.addUpdateTemplate(template);
  }

  deleteTemplate(id: any): Promise<any>{
    return this.campaignTemplateDataService.deleteTemplate(id);
  }
}
